import "../../components/AccountsBills/bills.css";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useLocation } from 'react-router-dom';

function UpdateExpenseDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const expenseDetailId = queryParams.get('expense_detail_id');
  const relocation_id = queryParams.get('relocation_id');

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [expenseDescription, setExpenseDescription] = useState([]);
  const [locationDetail, setLocationDetail] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [vendorDetail, setVendorDetail] = useState([]);
  const [pettyCashMaster, setPettyCashMaster] = useState([]);
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [expenseType, setExpenseType] = useState([]);
  const [costCenter, setCostCenter] = useState([]);
  const [subcostCenter, setSubCostCenter] = useState([]);
  const isUpdateMode = !!expenseDetailId;
  const storedUser = localStorage.getItem("name") || {};
  const [isReadOnly, setIsReadOnly] = useState(false);
  const fileInputRef = useRef(null);


  // const [formData, setFormData] = useState({
  //   expense_detail_id: null,
  //   relocation_id: relocation_id || null,
  //   bill_no: "",
  //   location: "",
  //   expense_date: "",
  //   expense_type: 1,
  //   expense_description: null,
  //   vendor_id: null,
  //   rate: 0,
  //   quantity: 0,
  //   sale_amount: 0,
  //   payment_mode: "",
  //   payment_made_by: "",
  //   expense_amount: 0,
  //   remarks: "",
  //   attachment: "",
  //   added_date: "",
  //   added_by: "",
  //   payment_status: 1,
  //   approved_by: "",
  //   expense_category: null,
  //   file_status: "",
  //   cost_center: "",
  //   sub_cost_center: "",
  //   payment_term: "",
  //   account: "",
  //   due_date: "",
  //   bill_status: "",
  //   tax: "",
  //   notes: "",
  //   attach_files_to_bill: "",
  // });


  const defaultFormData = {
    expense_detail_id: null,
    relocation_id: relocation_id || null,
    bill_no: "",
    location: "0",
    expense_date: "",
    expense_type: "0",
    expense_description: "0",
    vendor_id: "0",
    rate: "",
    quantity: "",
    sale_amount: "",
    payment_mode: "0",
    payment_made_by: "0",
    expense_amount: "",
    remarks: "",
    attachment: "",
    added_date: "",
    added_by: "",
    payment_status: "0",
    approved_by: "",
    expense_category: "0",
    file_status: "",
    cost_center: "0",
    sub_cost_center: "0",
    payment_term: "0",
    account: "0",
    due_date: "",
    bill_status: "0",
    tax: "0",
    notes: "",
    attach_files_to_bill: "",
  };
  const [formData, setFormData] = useState(defaultFormData);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
        };

        if (isUpdateMode) {
          const expenseDetailRes = await axios.get(
            `${baseAPI}userGet/GetExpenseDetails?expense_detail_id=${expenseDetailId}&relocation_id=${relocation_id}`,
            { headers }
          );
          setFormData({
            ...defaultFormData, // ensure safe defaults
            ...expenseDetailRes.data.data[0], // overwrite with fetched values
          });
        }
        else {
          setFormData((prev) => ({
            ...prev,
            added_by: storedUser || "Current User",
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    fetchExpenseMasterData();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedForm = {
      ...formData,
      [name]: value,
    };

    if (name === "expense_description") {
      const selectedExpense = expenseDescription.find(
        (exp) => exp.expense_description_id.toString() === value
      );
      if (selectedExpense) {
        updatedForm.expense_category = selectedExpense.expense_category_id || "0";
      }
    }


    if (name === "rate" || name === "quantity") {
      const rate = parseFloat(name === "rate" ? value : formData.rate) || 0;
      const quantity = parseFloat(name === "quantity" ? value : formData.quantity) || 0;
      updatedForm.expense_amount = (rate * quantity).toFixed(2);
    }

    // 🔹 GST Calculation
    const expenseAmt = parseFloat(updatedForm.expense_amount) || 0;
    const gstPercent = parseFloat(name === "tax" ? value : formData.tax) || 0;
    updatedForm.gst_amount = ((expenseAmt * gstPercent) / 100).toFixed(2);

    // 🔹 TDS Calculation
    const tdsPercent = parseFloat(name === "tds" ? value : formData.tds) || 0;
    updatedForm.tds_amount = ((expenseAmt * tdsPercent) / 100).toFixed(2);

    // 🔹 Payable Calculation: Expense + GST + TDS (ignoring TDS for now)
    updatedForm.payable_to_vendor = (
      expenseAmt -
      parseFloat(updatedForm.tds_amount || 0) +
      parseFloat(updatedForm.gst_amount || 0)
    ).toFixed(2);



    setFormData(updatedForm);
  };


  const handleCostChange = (e) => {
    const { name, value } = e.target;

    let updatedForm = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedForm);
    fetchSubCostCenter(e.target.value);
  };

  const fetchSubCostCenter = async (costCenterId) => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(`${baseAPI}adminGet/GetSubCostCenter?sub_cost_center_id=0&cost_center_id=${costCenterId}`, { headers });
      setSubCostCenter(response.data.data);
    } catch (error) {
      console.error("Error fetching sub cost center data:", error);
    }
  };


  const fetchExpenseMasterData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json",
      };

      const [
        expenseDescriptionRes,
        locationDetailRes,
        paymentModeRes,
        vendorDetailRes,
        pettyCashMasterRes,
        expenseTypeRes,
        expenseCategoryRes,
        costCenterRes,
        subCostCenterRes,
      ] = await Promise.all([
        axios.get(`${baseAPI}adminGet/GetExpenseDescriptions?expense_type=1&expense_category=0`, { headers }),
        axios.get(`${baseAPI}adminGet/GetLocations`, { headers }),
        axios.get(`${baseAPI}adminGet/GetPaymentMode`, { headers }),
        axios.get(`${baseAPI}adminGet/GETSupplier?SupplierID=0`, { headers }),
        axios.get(`${baseAPI}adminGet/GetPettyCashMaster`, { headers }),
        axios.get(`${baseAPI}adminGet/GetExpenseTypes`, { headers }),
        axios.get(`${baseAPI}adminGet/GetExpenseCategories`, { headers }),
        axios.get(`${baseAPI}adminGet/GetCostCenter?cost_center_id=0`, { headers }),
        axios.get(`${baseAPI}adminGet/GetSubCostCenter?sub_cost_center_id=0&cost_center_id=0`, { headers }),
      ]);
      setExpenseDescription(expenseDescriptionRes.data.data);
      setLocationDetail(locationDetailRes.data.data);
      setPaymentMode(paymentModeRes.data.data);
      setVendorDetail(vendorDetailRes.data.data);
      setPettyCashMaster(pettyCashMasterRes.data.data);
      setExpenseType(expenseTypeRes.data.data);
      setExpenseCategory(expenseCategoryRes.data.data);
      setCostCenter(costCenterRes.data.data);
      setSubCostCenter(subCostCenterRes.data.data);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };



  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json",
      };

      const payload = {
        ...formData,
        expense_detail_id: isUpdateMode ? formData.expense_detail_id : null,
        relocation_id: relocation_id || null,
      };

      const response = await axios.post(
        `${baseAPI}UserPost/InsertUpdateCmpExpenseDetail`,
        payload,
        { headers }
      );

      if (response.status === 200) {
        alert(isUpdateMode ? "Expense updated successfully!" : "Expense added successfully!");
        setIsReadOnly(true);
      } else {
        console.error("Unexpected response:", response);
        alert("Error saving expense!");
      }
    } catch (error) {
      console.error("Error saving expense:", error.response ? error.response.data : error.message);
      alert("Error saving expense!");
    }
  };



  function formatDate(dateString) {
    if (dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  }

  const handleUpload = (e) => {
    const { name, files } = e.target;
    if (!files || files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();

    reader.onloadend = () => {      
      const base64String = reader.result;      
      setFormData((prev) => ({
        ...prev,
        [name]: base64String,  
      }));
    };

    reader.readAsDataURL(file);
  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            width: "94%",
            backgroundColor: "#F4F4F4",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  {isUpdateMode ? "Update Expense" : "Add Expense"} | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>
                    &gt; Accounts & Finance
                  </span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>
                    &gt; Expense Details
                  </span>
                </h1>
              </div>
              <div style={{ width: "12rem" }}>
                {relocation_id ? (
                  <div style={{ backgroundColor: "#682465" }}>
                    <h5
                      style={{
                        color: "white",
                        fontSize: "16px",
                        padding: "10px",
                      }}
                    >
                      Lead ID:{relocation_id}
                    </h5>
                  </div>
                ) : null}
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    textAlign: "left",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                  Details
                </h2>

                <div className="p-4 bg-white shadow-md rounded-lg max-w-4xl mx-auto" >
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Date of Expense</label>
                      <input
                        className="form-control form-control-bills"
                        type="date"
                        name="expense_date"
                        placeholder="Please Enter*"
                        onChange={handleChange}
                        value={formatDate(formData.expense_date)}
                        disabled={isReadOnly}
                      />



                      {/* <span class="form-control form-control-expencsems">
                        {typeof formData.expense_date === 'string' ? formData.expense_date.slice(0, 10) : ''}
                      </span> */}
                    </div>
                    <div className="col-3">
                      <label className="form-label">Entry Date of Expense</label>
                      <span class="form-control form-control-expencsems">
                        {typeof formData.added_date === 'string' ? formData.added_date.slice(0, 10) : ''}
                      </span>
                    </div>

                    <div className="col-6">
                      <label className="form-label">Vendor Name<span>(If not registered, first add a new Vendor)</span></label>
                      <select class="form-control form-control-expencsems" name="vendor_id" onChange={handleChange} value={formData.vendor_id} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        {vendorDetail.map((exp) => (
                          <option key={exp.Vendor_Id} value={exp.Vendor_Id}>
                            {exp.VendorFirstName} {exp.VendorLastName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Location</label>
                      <select class="form-control form-control-expencsems" name="location" onChange={handleChange} value={formData.location} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        {locationDetail.map((location) => (
                          <option key={location.location_id} value={location.location_id}>
                            {location.location}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-6">
                      <label className="form-label">Expense Description</label>
                      <select class="form-control form-control-expencsems" name="expense_description" value={formData.expense_description} onChange={handleChange} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        {expenseDescription.map((exp) => (
                          <option key={exp.expense_description_id} value={exp.expense_description_id}>
                            {exp.description}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Sales Amount</label>
                      <input
                        type="text"
                        className="form-control form-control-bills"
                        placeholder="Enter"
                        name="sale_amount"
                        onChange={handleChange}
                        value={formData.sale_amount}
                        disabled={isReadOnly}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-2">
                      <label className="form-label">Rate</label>
                      <input type="text" class="form-control form-control-expencsems" name="rate" disabled={isReadOnly} value={formData.rate} onChange={handleChange} />
                    </div>
                    <div className="col-1">
                      <label className="form-label">Quantity</label>
                      <input type="text" class="form-control form-control-expencsems" name="quantity" disabled={isReadOnly} value={formData.quantity} onChange={handleChange} />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Expense Amount</label>
                      <input type="text" class="form-control form-control-expencsems" name="expense_amount" value={formData.expense_amount} disabled={isReadOnly} />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Expense Group</label>
                      <select class="form-control form-control-expencsems" name="expense_type" value={formData.expense_type} disabled={isReadOnly}   >
                        <option value="0">Select</option>
                        {expenseType.map((exp) => (
                          <option key={exp.expense_type_id} value={exp.expense_type_id}>
                            {exp.expense_type}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Expense Sub-Group</label>
                      <select class="form-control form-control-expencsems" name="expense_category" value={formData.expense_category} disabled={isReadOnly}  >
                        <option value="0">Select</option>
                        {expenseCategory.map((exp) => (
                          <option key={exp.expense_category_id} value={exp.expense_category_id}>
                            {exp.expense_type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Payment Mode</label>
                      <select class="form-control form-control-expencsems" name="payment_mode" value={formData.payment_mode} onChange={handleChange} disabled={isReadOnly}   >
                        <option value="0">Select</option>
                        {paymentMode.map((exp) => (
                          <option key={exp.payment_mode_id} value={exp.payment_mode_id}>
                            {exp.payment_mode}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-3">
                      <label className="form-label">Payment Made By</label>
                      <select class="form-control form-control-expencsems" name="payment_made_by" value={formData.payment_made_by}
                        disabled={formData.payment_mode !== "2"} onChange={handleChange} >
                        <option value="" >Select</option>
                        {pettyCashMaster.map((exp) => (
                          <option key={exp.employee_id} value={exp.employee_id}>
                            {exp.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Receipt Number</label>
                      <input type="text" class="form-control form-control-expencsems" name="bill_no" value={formData.bill_no} onChange={handleChange} disabled={isReadOnly} />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Document</label>
                      {formData?.attachment ? (
                        <a
                          style={{
                            color: "blueviolet",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontWeight: "bold",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${baseImageURL}Images/FieldOpsExpenseDocuments/${formData.attachment}`}
                        >
                          View Document
                        </a>
                      ) : (
                        <span style={{ color: "#999", fontWeight: "bold" }}>No Document</span>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-6">
                      <label className="form-label">Remark <span>(If Any)</span></label>
                      <input type="text" class="form-control form-control-expencsems" name="remarks" value={formData.remarks} onChange={handleChange} disabled={isReadOnly} />
                    </div>
                    <div className="col-3">
                      <label className="form-label">Payment Added By</label>
                      <span className="form-control form-control-expencsems" style={{ backgroundColor: "#f4f4f4" }}>
                        {formData.added_by}
                      </span>
                    </div>
                  </div>

                  <hr></hr>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Cost Center</label>
                      <select className="form-control form-control-bills" name="cost_center" onChange={handleCostChange} value={formData.cost_center} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        {costCenter.map((exp) => (
                          <option key={exp.cost_center_id} value={exp.cost_center_id}>
                            {exp.cost_center_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-6">
                      <label className="form-label">Sub-Cost Center</label>
                      <select className="form-control form-control-bills" id="sub_cost_center" name="sub_cost_center" onChange={handleChange} value={formData.sub_cost_center} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        {subcostCenter.map((exp) => (
                          <option key={exp.sub_cost_center_id} value={exp.sub_cost_center_id}>
                            {exp.sub_cost_center_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Payment Status</label>
                      <select className="form-control form-control-bills" value={formData.payment_status} onChange={handleChange} name="payment_status" disabled={isReadOnly} >
                        <option value="0" >Unpaid</option>
                        <option value="1" >Paid</option>
                      </select>
                    </div>

                  </div>


                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Due Date</label>
                      <input onChange={handleChange}
                        type="date"
                        id="due_date"
                        name="due_date"
                        placeholder="yyyy-mm-dd"
                        value={typeof formData.due_date === 'string' ? formData.due_date.slice(0, 10) : ''}
                        className="form-control form-control-bills"
                        disabled={isReadOnly}
                      />
                    </div>

                    <div className="col-3">
                      <label className="form-label">Payment Term</label>
                      <select className="form-control form-control-bills" name="payment_term" onChange={handleChange} value={formData.payment_term} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        <option value="1">Payment term 1</option>
                        <option value="2">Payment term 2</option>
                        <option value="3">Payment term 3</option>
                        <option value="4">Payment term 4</option>
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Account</label>
                      <select className="form-control form-control-bills" name="account" onChange={handleChange} value={formData.account} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        <option value="1">Account 1</option>
                        <option value="2">Account 2</option>
                        <option value="3">Account 3</option>
                        <option value="4">Account 4</option>
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Bill Status</label>
                      <select className="form-control form-control-bills" name="bill_status" onChange={handleChange} value={formData.bill_status} disabled={isReadOnly} >
                        <option value="0">Pending</option>
                        <option value="1">Done</option>
                      </select>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">GST Treatment</label>
                      <select className="form-control form-control-bills" name="tax" onChange={handleChange} value={formData.tax} disabled={isReadOnly} >
                        <option value="0">Select</option>
                        <option value="5">5 %</option>
                        <option value="10">10 %</option>
                        <option value="12">12 %</option>
                        <option value="18">18 %</option>
                        <option value="20">20 %</option>
                        <option value="30">30 %</option>
                      </select>
                    </div>

                    <div className="col-3">
                      <label className="form-label">GST Amount</label>
                      <input type="text" class="form-control form-control-expencsems" name="gst_amount" value={formData.gst_amount} disabled={isReadOnly} />
                    </div>

                    <div className="col-3">
                      <label className="form-label">TDS</label>
                      <input type="number" class="form-control form-control-expencsems" name="tds" value={formData.tds} onChange={handleChange} disabled={isReadOnly} />
                    </div>

                    <div className="col-3">
                      <label className="form-label">TDS Amount</label>
                      <input type="text" class="form-control form-control-expencsems" name="tds_amount" value={formData.tds_amount} disabled={isReadOnly} />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Payable to Vendor</label>
                      <input type="text" class="form-control form-control-expencsems" name="payable_to_vendor" value={formData.payable_to_vendor} disabled={isReadOnly} />
                    </div>
                  </div>
                </div>

                {/* <div className="row">
                  <div className="col-6">
                  </div>
                  <div className="col-6 bg-light p-3 rounded" style={{ border: "1px solid grey" }}>
                    <div className="d-flex justify-content-between">
                      <span>Taxable Amount</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span
                        className="d-flex"
                        style={{ flexDirection: "column" }}
                      >
                        Discount{" "}
                        <small className="text-primary">Apply after tax</small>
                      </span>
                      <div className="d-flex" style={{ paddingLeft: "5.5rem" }}>
                        <input
                          type="number"
                          className="form-control w-50"
                          defaultValue="0.00"
                        />
                        <span className="ms-2">%</span>
                      </div>
                    </div>

                    <hr style={{ opacity: "1 !important" }} ></hr>
                    <div className="d-flex justify-content-between pb-3">
                      <span>CGST [9%]</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex justify-content-between pb-5">
                      <span>SGST [9%]</span>
                      <span>0.00</span>
                    </div>
                    <div className="d-flex  align-items-center">
                      <span>Total Tax Amount</span>
                      <div className="d-flex" style={{ paddingLeft: "5.5rem" }}>
                        <input
                          type="number"
                          className="form-control w-50"
                          defaultValue="0.00"
                        />
                        <span className="ms-2">%</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <input type="checkbox" className="me-2" /> TDS
                      <input type="checkbox" className="ms-3 me-2" /> TCS
                      <div
                        className="d-flex justify-content-between w-100"
                        style={{ paddingLeft: "5.5rem" }}
                      >
                        <select
                          className="form-control"
                          style={{ width: "35%" }}
                        >
                          <option>Select a Tax</option>
                        </select>
                        <span className="ms-auto">-0.00</span>{" "}

                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-between"
                      style={{ marginLeft: "-9px" }}
                    >
                      <select className="form-control" style={{ width: "22%" }}>
                        <option>Adjustment</option>
                      </select>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="-"
                        style={{ width: "18%", marginLeft: "40px" }}
                      />
                      <span className="ms-auto">-0.00</span>{" "}

                    </div>
                    <hr />
                    <div className="d-flex justify-content-between font-weight-bold">
                      <span>Total</span>
                      <span>0.00</span>
                    </div>
                  </div>
                </div> */}

                <br></br>

                <div className="row rounded" style={{ border: "1px solid grey" }}>
                  {/* Left Notes Section */}
                  <div className="col-6 bg-light p-3 rounded">
                    <label htmlFor="subjetBill" className="form-label">Notes</label>
                    <textarea disabled={isReadOnly}
                      name="notes"
                      onChange={handleChange}
                      id="notes" className="form-control form-control-bills" value={formData.notes}
                    ></textarea>
                  </div>
                  <div className="col-1 d-flex justify-content-center align-items-center bg-light p-3 rounded">
                    <div className="vr"></div>
                  </div>

                  <div className="col-5 bg-light p-3 rounded">
                    <label htmlFor="fileInput" className="form-label">Attach File to Bill</label>

                    {formData.attach_files_to_bill ? (
                      <a
                        href={`${baseImageURL}Images/FieldOpsExpenseDocuments/${formData.attach_files_to_bill}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "blueviolet",
                          textDecoration: "none",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        View Document
                      </a>
                    ) : (
                      <input
                        type="file"
                        id="attach_files_to_bill"
                        name="attach_files_to_bill"
                        className="form-control form-control-bills form-control-bills-new"
                        ref={fileInputRef}
                        onChange={handleUpload}
                      />
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "end", paddingTop: "20px" }}>
                  {!isReadOnly && (
                    <div style={{ textAlign: "end", paddingTop: "20px" }}>
                      <button
                        className="text-red-500 border-none cursor-pointer"
                        style={{ background: '#5B489D', color: 'white' }}
                        onClick={handleSave}
                      >
                        {isUpdateMode ? "Update" : "Add"}
                      </button>
                    </div>
                  )}
                </div>
              </Wrapper>
            </div>
          </div>
        </div >
      </div >
    </>
  );
}

export default UpdateExpenseDetails;
